

// const assignmentEricssonMainInfo = "Utvecklar en hårdvarunära applikation i C/C++ för basstations radio. Utför stresstest och diagnostik av ASIC, PCIe. CPRI, ethernet och sensorer. Innefattar konfiguration och initialisering av samtliga SERDES länkar.";
// const assignmentEricssonItem1 = "Bidrog med att utveckla mjukvara för att identifiera och verifiera hårdvarufel i SoC:er, vilket förbättrade felanalyser och förkortade felsökningstiden i produktions- och utvecklingsmiljö. ";
// const assignmentEricssonItem2 = "Ansvarade för och portade ASIC test-mjukvara till ny SoC och plattform som minimerar risken för returer.";
// const assignmentEricssonItem3 = "Utvecklade ny i2c drivrutin för sekundär SoC för att möjliggöra testning av sekundära PCIe- och SFP-länkar.";

const assignmentEricssonItem1 = "Developed a low-level C/C++ application for base station radio hardware. Performed stress testing and diagnostics of ASICs, PCIe, CPRI, Ethernet, and sensors, including configuration and initialization of all SERDES links.";
const assignmentEricssonItem2 = "Contributed to software that identifies and validates hardware faults in SoCs, improving fault analysis and reducing debugging time in both production and development environments.";
const assignmentEricssonItem3 = "Owned and ported ASIC test software to a new SoC and platform, reducing the risk of product returns.";
const assignmentEricssonItem4 = "Developed a new I2C driver for a secondary SoC to enable testing of secondary PCIe and SFP links.";


const AssignmentEricsson = {
    desc: [
    assignmentEricssonItem1,
    assignmentEricssonItem2,
    assignmentEricssonItem3,
    assignmentEricssonItem4,
    ],
    skill: ['C/C++', 'Python', 'Yocto', 'PCIe', 'CPRI','SERDES'],
};

export default AssignmentEricsson;




